import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateSep = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / September`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#D0DBFF)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#D0DBFF)",
								stroke: "var(--sticker-dark,#505772)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#505772)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7382
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M11.5213 12.9921 C11.1265 12.9922 10.7666 12.9281 10.4412 12.8001 C10.1212 12.6668 9.8626 12.4694 9.6652 12.2081 C9.4732 11.9415 9.3693 11.6055 9.3532 11.2001 L10.6812 11.2002 C10.7025 11.3868 10.7773 11.5549 10.9052 11.7041 C11.0386 11.8535 11.2386 11.9281 11.5053 11.9281 C11.7346 11.9282 11.9052 11.8775 12.0172 11.7761 C12.1345 11.6748 12.1932 11.5415 12.1932 11.3762 C12.1932 11.3015 12.1799 11.2322 12.1532 11.1681 C12.1319 11.1042 12.0866 11.0428 12.0173 10.9842 C11.9479 10.9202 11.8413 10.8562 11.6972 10.7922 C11.5586 10.7281 11.372 10.6588 11.1372 10.5841 C10.6999 10.4455 10.3585 10.2828 10.1132 10.0961 C9.8679 9.9095 9.6945 9.7095 9.5933 9.4961 C9.4973 9.2828 9.4492 9.0641 9.4492 8.8402 C9.4546 8.4775 9.5452 8.1762 9.7212 7.9362 C9.8973 7.6909 10.1319 7.5068 10.4252 7.3841 C10.7185 7.2615 11.0466 7.2001 11.4092 7.2001 C11.7719 7.2001 12.1026 7.2642 12.4012 7.3922 C12.7052 7.5148 12.9506 7.6988 13.1372 7.9442 C13.3239 8.1895 13.4199 8.4935 13.4253 8.8562 L12.0653 8.8562 C12.0599 8.7121 11.9986 8.5762 11.8812 8.4481 C11.7639 8.3201 11.5906 8.2562 11.3612 8.2561 C11.1959 8.2615 11.0546 8.3095 10.9372 8.4002 C10.8252 8.4855 10.7692 8.6081 10.7693 8.7681 C10.7693 8.9068 10.8279 9.0268 10.9452 9.1281 C11.0626 9.2295 11.2279 9.3228 11.4412 9.4082 C11.6599 9.4935 11.9132 9.5842 12.2013 9.6802 C12.4199 9.7548 12.6119 9.8428 12.7772 9.9442 C12.9479 10.0401 13.0893 10.1548 13.2013 10.2881 C13.3133 10.4162 13.3986 10.5628 13.4573 10.7281 C13.5159 10.8935 13.5452 11.0802 13.5453 11.2881 C13.5453 11.6294 13.4572 11.9282 13.2812 12.1841 C13.1106 12.4402 12.8733 12.6402 12.5693 12.7841 C12.2652 12.9228 11.9159 12.9921 11.5213 12.9921 Z M14.0506 12.8961 L14.0506 7.2962 L17.7306 7.2961 L17.7306 8.3841 L15.3146 8.3842 L15.3146 9.4001 L17.3546 9.4001 L17.3546 10.4881 L15.3146 10.4882 L15.3147 11.8081 L17.7306 11.8082 L17.7306 12.8962 L14.0506 12.8961 Z M18.2987 12.8962 L18.2987 7.2961 L20.5227 7.2961 C20.9067 7.2962 21.2534 7.3655 21.5627 7.5041 C21.8721 7.6429 22.1147 7.8428 22.2908 8.1042 C22.4721 8.3654 22.5628 8.6775 22.5628 9.0401 C22.5627 9.3975 22.4748 9.7095 22.2987 9.9762 C22.1281 10.2375 21.8881 10.4402 21.5787 10.5841 C21.2747 10.7281 20.9227 10.8001 20.5228 10.8002 L19.5627 10.8001 L19.5628 12.8961 L18.2987 12.8962 Z M19.5627 9.7202 L20.4908 9.7202 C20.7894 9.7201 20.9947 9.6535 21.1067 9.5201 C21.2241 9.3814 21.2828 9.2215 21.2827 9.0401 C21.2827 8.8695 21.224 8.7174 21.1067 8.5841 C20.9948 8.4455 20.7894 8.3761 20.4907 8.3761 L19.5627 8.3762 L19.5627 9.7202 Z",
							id: `${__svgrId}-SEP`,
							style: { fill: "var(--sticker-dark,#505772)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.1531,
							y1: 19.1321,
							y2: 19.1322
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7504,
							x2: 17.7503,
							y1: 15.3984,
							y2: 27.0675
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#505772)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.146",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#505772)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateSep;
